import { render, staticRenderFns } from "./jnzpffb.vue?vue&type=template&id=119afd05&"
import script from "./jnzpffb.vue?vue&type=script&lang=js&"
export * from "./jnzpffb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports